(function () {
  const startTime = Date.now();
  const interval = setInterval(() => {
    if (Date.now() - startTime > 10000) { clearInterval(interval); return; }
    const widget = window.tlGiftInCartWidget;
    if (!widget) return;
    clearInterval(interval);

    const CS = widget.CONDITION_STATE;

    const seqByKey = new Map();
    let seqCounter = 0;

    const isEligible = (s) => !s.isStopped && s.conditionState === CS.MET_BEFORE_CLAIM;

    function computeChosenKey() {
      const anyClaimed = widget.offers.some((o) => {
        const s = widget.getOfferState(o.id, o.module);
        return s.claimedCount >= 1 || s.conditionState === CS.MET_AFTER_CLAIM;
      });
      if (anyClaimed) { seqByKey.clear(); return null; }

      const domOrderKeys = Array.from(document.querySelectorAll(".salepify-gic__offer-card"))
        .map((c) => c.getAttribute("data-rule-key"));

      const eligibleKeys = new Set();
      widget.offers.forEach((o) => {
        const key = widget.utils.getRuleKey(o.id, o.module);
        if (isEligible(widget.getOfferState(o.id, o.module))) eligibleKeys.add(key);
      });

      for (const key of Array.from(seqByKey.keys())) {
        if (!eligibleKeys.has(key)) seqByKey.delete(key);
      }

      const newlyEligible = domOrderKeys.filter((key) => eligibleKeys.has(key) && !seqByKey.has(key));
      eligibleKeys.forEach((key) => { if (!seqByKey.has(key) && !newlyEligible.includes(key)) newlyEligible.push(key); });
      newlyEligible.forEach((key) => seqByKey.set(key, seqCounter++));

      let chosenKey = null, minSeq = Infinity;
      eligibleKeys.forEach((key) => {
        const s = seqByKey.get(key);
        if (s < minSeq) { minSeq = s; chosenKey = key; }
      });
      return chosenKey;
    }

    function applyOneSelectorVisibility() {
      const chosenKey = computeChosenKey();

      widget.offers.forEach((offer) => {
        const key = widget.utils.getRuleKey(offer.id, offer.module);
        const cards = document.querySelectorAll(`.salepify-gic__offer-card[data-rule-key="${key}"]`);
        if (key === chosenKey) {
          cards.forEach((c) => { c.style.display = ""; });
        } else {
          cards.forEach((c) => { c.style.display = "none"; });
          const openSel = document.querySelector(
            `.salepify-gic__gift-selector-modal[open] .salepify-gic__gift-selector-container[data-rule-key="${key}"]`
          );
          if (openSel) widget.toggleGiftSelector(false, offer.id, offer.module);
        }
      });

      const visibleCount = chosenKey ? 1 : 0;
      const gt = widget.translations?.general || widget.GENERAL_TRANSLATION?.general || {};
      let text = gt.offer_number || "";
      if (widget.utils?.replaceVariable) text = widget.utils.replaceVariable(text, "{{offer_counts}}", String(visibleCount));
      document.querySelectorAll(".salepify-gic__offer-number").forEach((el) => { el.textContent = text; });
      document.querySelectorAll(".salepify-gic__gic-container").forEach((el) => { el.style.display = visibleCount > 0 ? "" : "none"; });
    }

    const rootPath = window.Shopify?.routes?.root ?? "/";
    const isCartPage = window.location.pathname === `${rootPath}cart` || window.location.pathname === "/cart";
    const repositionGicContainer = () => {
      if (!isCartPage) return;
      const container = document.querySelector(".salepify-gic__gic-container");
      const cartItems = document.querySelector("#main-cart-items") || document.querySelector(".cart__items");
      if (container && cartItems && cartItems.nextElementSibling !== container) {
        cartItems.insertAdjacentElement("afterend", container);
      }
    };

    const originalUpdateAllOfferCardsUI = widget.updateAllOfferCardsUI;
    widget.updateAllOfferCardsUI = async function () {
      await originalUpdateAllOfferCardsUI.call(this);
      applyOneSelectorVisibility();
      repositionGicContainer();
    };

    widget.updateAllOfferCardsUI();
  }, 100);
})();
